import { Formik } from 'formik'
import { useSessionQuery } from '../../api/api'
import TextInput from '../../components/TextInput/TextInput'
import { useState } from 'react'
import GeneralModal from '../../components/GeneralModal/GeneralModal'
import * as Yup from 'yup'

const AccountSettingsForm = ({ user, onSubmit }) => {
  const [nameLocked, setNameLocked] = useState(true)
  const [nameUnlockModalIsOpen, setNameUnlockModalIsOpen] = useState(false)
  const schema = Yup.object().shape({
    name: Yup.string().required('Username is a required field'),
    displayName: Yup.string().required('Display Name is a required field'),
  })
  return (
    <div>
      <Formik
        initialValues={user}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({ values, isValid, handleChange, handleSubmit }) => (
          <>
            <div className="mb-2">
              <TextInput
                label="Username"
                value={values.name}
                name="name"
                onChange={handleChange}
                isLocked={nameLocked}
                lockedLabel={values.name}
                onUnlock={() => {
                  setNameUnlockModalIsOpen(true)
                }}
              />
            </div>
            <div className="mb-2">
              <TextInput
                label="Display Name"
                value={values.displayName}
                name="displayName"
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <button
                type="button"
                className="button bg-pink hover:bg-pink-off"
                disabled={!isValid}
                onClick={() => handleSubmit()}
              >
                Save
              </button>
            </div>
          </>
        )}
      </Formik>
      <GeneralModal
        isOpen={nameUnlockModalIsOpen}
        onRequestClose={() => setNameUnlockModalIsOpen(false)}
        title="Change Username?"
        buttons={[
          {
            text: 'Change',
            className: 'button bg-pink hover:bg-pink-off',
            onClick: () => {
              setNameUnlockModalIsOpen(false)
              setNameLocked(false)
            },
          },
        ]}
      >
        Changing your username will also change all portfolio links currently at{' '}
        {user.name}.sharefol.io. Are you sure you want to change your username?
      </GeneralModal>
    </div>
  )
}

export default AccountSettingsForm
